export default __webpack_public_path__ + "static/1063-108fe57a803f09b788eb66ae565c53e6.gif";